import { toQuery } from '@debbie/common/dist/util/index.js';
import { format } from 'date-fns';
import { collectionEngineV1 } from '../apis.js';
import { insightsQuery } from '../insights/filter-params.js';
const tribunalAPIV1 = collectionEngineV1('/tribunal', true);
export const createTribunalCase = (newTribunalCase) => tribunalAPIV1('POST', `/cases`, {
    body: newTribunalCase,
});
export const getTribunalCases = (caseId, casualConsistency) => tribunalAPIV1('GET', `/cases/${caseId}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const patchCase = (tribunalCaseId, patch) => tribunalAPIV1('PATCH', `/cases/${tribunalCaseId}`, {
    body: patch,
});
export const createTribunalJob = (newTribunalJob) => tribunalAPIV1('POST', `/jobs`, {
    body: newTribunalJob,
});
export const getTribunalJobs = (tribunalCaseId) => tribunalAPIV1('GET', `/jobs/${tribunalCaseId}`);
export const getMultipleTribunalJobs = (filters, page, pageSize) => tribunalAPIV1('GET', `/jobs?${toQuery({
    page,
    pageSize,
    types: filters.types,
    sortKey: filters.sortKey,
    sortDirection: filters.sortDirection,
    assignee: filters.assignee,
    states: filters.states,
    courtIds: filters.courtIds,
    toDate: filters.toDate
        ? format(new Date(filters.toDate), 'yyyy-MM-dd')
        : undefined,
    fromDate: filters.fromDate
        ? format(new Date(filters.fromDate), 'yyyy-MM-dd')
        : undefined,
    caseFilter: filters.caseFilter,
    debtorUserId: filters.debtorUserId,
    meetingTypeIds: filters.meetingTypeIds,
    distraintTypes: filters.distraintTypes,
})}`);
export const delJob = (jobId) => tribunalAPIV1('DELETE', `/jobs/${jobId}`);
export const patchJob = (jobId, patch) => tribunalAPIV1('PATCH', `/jobs/${jobId}`, {
    body: patch,
});
export const getCourtSpeedBenchmark = ({ caseGroupIds = [], creditorIds = [], } = {}) => tribunalAPIV1('GET', `/insights/court-speed${insightsQuery({ base: {}, scope: { caseGroupIds, creditorIds } })}`);
export const getTribunalOutcomes = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => tribunalAPIV1('GET', `/insights/outcomes${insightsQuery({ base: { from, to }, scope: { caseGroupIds, creditorIds } })}`);
export const getTribunalVolumeByMonth = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => tribunalAPIV1('GET', `/insights/volume-by-month${insightsQuery({ base: { from, to }, scope: { caseGroupIds, creditorIds } })}`);
export const getTribunalCasesByCourt = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => tribunalAPIV1('GET', `/insights/cases-by-court${insightsQuery({ base: { from, to }, scope: { caseGroupIds, creditorIds } })}`);
//# sourceMappingURL=tribunal.js.map